export function isFocusedReaderRoute(pathname: string | null): boolean {
  return pathname === '/read' || Boolean(pathname?.startsWith('/read/'));
}

/** Focused reading, Lumina and admin retain their own themes. */
export function hasSiteScenery(pathname: string | null): boolean {
  if (!pathname || isFocusedReaderRoute(pathname)) return false;
  return !['/welcome', '/pricing', '/studio', '/admin'].some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}
